import { Component, OnInit } from '@angular/core';
import 'jquery';
import { ViewEncapsulation } from '@angular/core';
import { BoService } from '../services/bo.service';

declare var $: any;

@Component({
  selector: 'app-configurer-ma-liste',
  templateUrl: './configurer-ma-liste.component.html',
  styleUrls: ['./configurer-ma-liste.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class ConfigurerMaListeComponent implements OnInit {

  constructor(private boService: BoService) { }

  ngOnInit() {
    let t = this;
    $(document).ready(function(){
      //--- Recuperation et création des data utiles pour jq :  ------------------
      //var allTpl;
      var dataEvents;
      var dataList;
      var dataListTpl=[];
      var term='';
      var respmo=0;
      var maxScroll=0;
      var cus=['<span style="color:#ff8239;background-color:#ff823930">','</span>'];
      //--------------------------------------------------------------------------
      //--- Initialisation globale : ---------------------------------------------
      $('.menubo,.headerbo').css({'display':'block'});
      var darkMode='off';
      var contrastMode='off';
      if(JSON.parse(localStorage.getItem('infoUser')).darkMode=='on'){darkMode='on'};
      if(JSON.parse(localStorage.getItem('infoUser')).contrastMode=='on'){contrastMode='on'};
      var wiw=$(window).width();
      $('#htitsec').html('Configurer');
      $('#htitsec2').html('Ma liste');
      $('.menubs').attr('id','');$('.menubs-3').attr('id','actif1');
      $('.secmenu2bs').attr('id','');$('.3s2').attr('id','actif2');
      if(wiw>610){
        $('#htitsec,#htitsec2,#fles').css({'display':'inline'});
      }else{
        $('#htitsec2').css({'display':'inline'});
        $('#fles').css({'display':'none'});
      };
      $('.headerbo').css({'border-color':'#b4aaaa49','box-shadow':'0 6px 10px -1px rgba(0,0,0,0.00)'});
      $(window).scroll(function(){
        var sw= $(this).scrollTop();
        if(sw>120){
          $('.headerbo').css({'border-color':'#b4aaaa00','box-shadow':'0 6px 10px -1px rgba(0,0,0,0.05)'});
        }else{
          $('.headerbo').css({'border-color':'#b4aaaa49','box-shadow':'0 6px 10px -1px rgba(0,0,0,0.00)'});
        };
      });
      $(window).scrollTop(0);
      $('body').css({'overflow':'hidden'});
      if(wiw<=900){
        respmo=1;
      };
      //--------------------------------------------------------------------------
      //--- Initialisation du contenu  : -----------------------------------------
      dataList=JSON.parse(localStorage.getItem('dataList'));
      dataListTpl=dataList.tpl;
      //dataEvents=JSON.parse(localStorage.getItem('dataEvents'));
      //loadTpl(dataEvents);
      t.boService.getAllTpl().then(data => {
        dataEvents=data;
        loadTpl(dataEvents);
        maxScroll = (($('.contLiTpl').height())-($('.contTpl').height()))-1;
        t.boService.screenMode(darkMode,contrastMode);
        $('.blocLoader').fadeOut(300);
      })
      .catch(error => {
        console.log(error);
        t.boService.errorLoad();
      });
      function loadTpl(x){
        $('.contLiTpl').html('');
        if(x.length>0){
          $('.txtnoev').fadeOut(0);
          var n=0;
          for(var i=0;i<x.length;i++){
            n++;
            var cliev='liEv';
            var evname=x[i].name;

            var codcheckEv='';
            var stybulcheckEv='bulce0';
            var txtnbtpl="billet sélectionné";

            var cbs=['blocSource','blocSource','blocSource'];
          
            var codcheckSrc=['','',''];
            var stybulcheckSrc=['bulcs0','bulcs0','bulcs0'];

            var ischeckedTpl=0;
            var codcheckTpl='';
            var countcheck=0;
            var qtAll=0;

            var csOnline='';
            var qtOnline=0;
            var qtcheckOnline=0;

            var csOnsite='';
            var qtOnsite=0;
            var qtcheckOnsite=0;

            var csImport='';
            var qtImport=0;
            var qtcheckImport=0;

            var codeSelect='<select class="inScanTpl"><option value="0">0</option><option value="1" selected>1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option><option value="5">5</option><option value="10">10</option><option value="autre">Autre</option><option value="infinit">Illimité</option></select><div class="icselScan"><i class="fas fa-sort"></i></div>';
        
            for(var u=0;u<x[i].tplOnline.length;u++){
              var tplname=x[i].tplOnline[u].name;
              ischeckedTpl=0;
              codcheckTpl='';
              var scanNbr=0;
              var infinity=false;
              for(var q=0;(q<dataListTpl.length)&&(ischeckedTpl==0);q++){
                if(x[i].tplOnline[u]._id==dataListTpl[q].id){
                  countcheck++;
                  ischeckedTpl=1;
                  scanNbr=dataListTpl[q].scanNbr;
                  if(dataListTpl[q].infinity){
                    if(dataListTpl[q].infinity==true){
                      infinity=true;
                    };
                  };
                };
              };
              if(ischeckedTpl==1){
                codcheckTpl='checked';
              };
              qtOnline++;
              var lg="";
              if(qtOnline%2==0){
                lg="liTplG";
              };
              if(ischeckedTpl==1){
                qtcheckOnline++;
              };
              var priceTpl='-';
              if(x[i].tplOnline[u].prixVente){
                priceTpl=parseFloat(x[i].tplOnline[u].prixVente).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace(/\./g, ',')+' €';
              };
              var continfinitC='';
              if(infinity==true){
                continfinitC='continfinitOn';
              };
              var inScanTplC='';
              if(infinity==true || ischeckedTpl==0){
                inScanTplC='inScanTplOff';
              };
              csOnline+='<div id="'+x[i].tplOnline[u]._id+'" class="liTpl '+lg+'" mod0="'+codcheckTpl+'" mod1="'+codcheckTpl+'" nbscan0="'+scanNbr+'" nbscan1="'+scanNbr+'" inf0="'+infinity+'" inf1="'+infinity+'"><div class="contcheckTpl"><input type="checkbox" class="inCheckTpl" id="inCheckTpl0A'+x[i].tplOnline[u]._id+'" '+codcheckTpl+'><label class="labCheckTpl" for="inCheckTpl0A'+x[i].tplOnline[u]._id+'"><i class="fas fa-check icCheckTpl"></i></label></div><div class="nameTpl">'+tplname+'</div><div class="priceTpl">'+priceTpl+'</div><div class="nbScanTpl"><input class="inScanTpl '+inScanTplC+'" type="number" min="0" value="'+scanNbr+'"></div></div>';
              // avec infinity fn :
              /* csOnline+='<div id="'+x[i].tplOnline[u]._id+'" class="liTpl '+lg+'" mod0="'+codcheckTpl+'" mod1="'+codcheckTpl+'" nbscan0="'+scanNbr+'" nbscan1="'+scanNbr+'" inf0="'+infinity+'" inf1="'+infinity+'"><div class="contcheckTpl"><input type="checkbox" class="inCheckTpl" id="inCheckTpl0A'+x[i].tplOnline[u]._id+'" '+codcheckTpl+'><label class="labCheckTpl" for="inCheckTpl0A'+x[i].tplOnline[u]._id+'"><i class="fas fa-check icCheckTpl"></i></label></div><div class="nameTpl">'+tplname+'</div><div class="priceTpl">'+priceTpl+'</div><div class="nbScanTpl"><input class="inScanTpl '+inScanTplC+'" type="number" min="0" value="'+scanNbr+'"><div class="continfinit '+continfinitC+'"><i class="fa-solid fa-infinity"></i></div></div></div>'; */
            };
            for(var u=0;u<x[i].tplOnsite.length;u++){
              var tplname=x[i].tplOnsite[u].name;
              ischeckedTpl=0;
              codcheckTpl='';
              var scanNbr=0;
              var infinity=false;
              for(var q=0;(q<dataListTpl.length)&&(ischeckedTpl==0);q++){
                if(x[i].tplOnsite[u]._id==dataListTpl[q].id){
                  countcheck++;
                  ischeckedTpl=1;
                  scanNbr=dataListTpl[q].scanNbr;
                  if(dataListTpl[q].infinity){
                    if(dataListTpl[q].infinity==true){
                      infinity=true;
                    };
                  };
                };
              };
              if(ischeckedTpl==1){
                codcheckTpl='checked';
              };
              qtOnsite++;
              var lg="";
              if(qtOnsite%2==0){
                lg="liTplG";
              };
              if(ischeckedTpl==1){
                qtcheckOnsite++;
              };
              var priceTpl='-';
              if(x[i].tplOnsite[u].prixVente){
                priceTpl=parseFloat(x[i].tplOnsite[u].prixVente).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace(/\./g, ',')+' €';
              };
              var continfinitC='';
              if(infinity==true){
                continfinitC='continfinitOn';
              };
              var inScanTplC='';
              if(infinity==true || ischeckedTpl==0){
                inScanTplC='inScanTplOff';
              };
              csOnsite+='<div id="'+x[i].tplOnsite[u]._id+'" class="liTpl '+lg+'" mod0="'+codcheckTpl+'" mod1="'+codcheckTpl+'" nbscan0="'+scanNbr+'" nbscan1="'+scanNbr+'" inf0="'+infinity+'" inf1="'+infinity+'"><div class="contcheckTpl"><input type="checkbox" class="inCheckTpl" id="inCheckTpl0A'+x[i].tplOnsite[u]._id+'" '+codcheckTpl+'><label class="labCheckTpl" for="inCheckTpl0A'+x[i].tplOnsite[u]._id+'"><i class="fas fa-check icCheckTpl"></i></label></div><div class="nameTpl">'+tplname+'</div><div class="priceTpl">'+priceTpl+'</div><div class="nbScanTpl"><input class="inScanTpl '+inScanTplC+'" type="number" min="0" value="'+scanNbr+'"></div></div>';
              // avec infinity fn :
              /* csOnsite+='<div id="'+x[i].tplOnsite[u]._id+'" class="liTpl '+lg+'" mod0="'+codcheckTpl+'" mod1="'+codcheckTpl+'" nbscan0="'+scanNbr+'" nbscan1="'+scanNbr+'" inf0="'+infinity+'" inf1="'+infinity+'"><div class="contcheckTpl"><input type="checkbox" class="inCheckTpl" id="inCheckTpl0A'+x[i].tplOnsite[u]._id+'" '+codcheckTpl+'><label class="labCheckTpl" for="inCheckTpl0A'+x[i].tplOnsite[u]._id+'"><i class="fas fa-check icCheckTpl"></i></label></div><div class="nameTpl">'+tplname+'</div><div class="priceTpl">'+priceTpl+'</div><div class="nbScanTpl"><input class="inScanTpl '+inScanTplC+'" type="number" min="0" value="'+scanNbr+'"><div class="continfinit '+continfinitC+'"><i class="fa-solid fa-infinity"></i></div></div></div>'; */
            };
            for(var u=0;u<x[i].tplImport.length;u++){
              var tplname=x[i].tplImport[u].name;
              ischeckedTpl=0;
              codcheckTpl='';
              var scanNbr=0;
              var infinity=false;
              for(var q=0;(q<dataListTpl.length)&&(ischeckedTpl==0);q++){
                if(x[i].tplImport[u]._id==dataListTpl[q].id){
                  countcheck++;
                  ischeckedTpl=1;
                  scanNbr=dataListTpl[q].scanNbr;
                  if(dataListTpl[q].infinity){
                    if(dataListTpl[q].infinity==true){
                      infinity=true;
                    };
                  };
                };
              };
              if(ischeckedTpl==1){
                codcheckTpl='checked';
              };
              qtImport++;
              var lg="";
              if(qtImport%2==0){
                lg="liTplG";
              };
              if(ischeckedTpl==1){
                qtcheckImport++;
              };
              var priceTpl='-';
              if(x[i].tplImport[u].prixVente){
                priceTpl=parseFloat(x[i].tplImport[u].prixVente).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace(/\./g, ',')+' €';
              };
              var continfinitC='';
              if(infinity==true){
                continfinitC='continfinitOn';
              };
              var inScanTplC='';
              if(infinity==true || ischeckedTpl==0){
                inScanTplC='inScanTplOff';
              };
              csImport+='<div id="'+x[i].tplImport[u]._id+'" class="liTpl '+lg+'" mod0="'+codcheckTpl+'" mod1="'+codcheckTpl+'" nbscan0="'+scanNbr+'" nbscan1="'+scanNbr+'" inf0="'+infinity+'" inf1="'+infinity+'"><div class="contcheckTpl"><input type="checkbox" class="inCheckTpl" id="inCheckTpl0A'+x[i].tplImport[u]._id+'" '+codcheckTpl+'><label class="labCheckTpl" for="inCheckTpl0A'+x[i].tplImport[u]._id+'"><i class="fas fa-check icCheckTpl"></i></label></div><div class="nameTpl">'+tplname+'</div><div class="priceTpl">'+priceTpl+'</div><div class="nbScanTpl"><input class="inScanTpl '+inScanTplC+'" type="number" min="0" value="'+scanNbr+'"></div></div>';
              // avec infinity fn :
              /* csImport+='<div id="'+x[i].tplImport[u]._id+'" class="liTpl '+lg+'" mod0="'+codcheckTpl+'" mod1="'+codcheckTpl+'" nbscan0="'+scanNbr+'" nbscan1="'+scanNbr+'" inf0="'+infinity+'" inf1="'+infinity+'"><div class="contcheckTpl"><input type="checkbox" class="inCheckTpl" id="inCheckTpl0A'+x[i].tplImport[u]._id+'" '+codcheckTpl+'><label class="labCheckTpl" for="inCheckTpl0A'+x[i].tplImport[u]._id+'"><i class="fas fa-check icCheckTpl"></i></label></div><div class="nameTpl">'+tplname+'</div><div class="priceTpl">'+priceTpl+'</div><div class="nbScanTpl"><input class="inScanTpl '+inScanTplC+'" type="number" min="0" value="'+scanNbr+'"><div class="continfinit '+continfinitC+'"><i class="fa-solid fa-infinity"></i></div></div></div>'; */
            };
            var hins1='';
            if(qtOnline==0){csImport='<div class="txtnoTpl tnt1"></div>';}
            else{stybulcheckSrc[0]='bulcs1';hins1='<div class="hinfoNbScan"></div>';}
            if(qtcheckOnline>0){
              stybulcheckSrc[0]='bulcs2';
              if(qtcheckOnline==qtOnline){codcheckSrc[0]='checked';};
            };
            var hins2='';
            if(qtOnsite==0){csOnsite='<div class="txtnoTpl tnt2"></div>';}
            else{stybulcheckSrc[1]='bulcs1';hins2='<div class="hinfoNbScan"></div>';}
            if(qtcheckOnsite>0){
              stybulcheckSrc[1]='bulcs2';
              if(qtcheckOnsite==qtOnsite){codcheckSrc[1]='checked';};
            };
            var hins3='';
            if(qtImport==0){csImport='<div class="txtnoTpl tnt3"></div>';}
            else{stybulcheckSrc[2]='bulcs1';hins3='<div class="hinfoNbScan"></div>';}
            if(qtcheckImport>0){
              stybulcheckSrc[2]='bulcs2';
              if(qtcheckImport==qtImport){codcheckSrc[2]='checked';};
            };
            qtAll=qtOnline+qtOnsite+qtImport;
            if(qtAll!=0){stybulcheckEv='bulce1';};
            if(countcheck>0){
              stybulcheckEv='bulce2';
              txtnbtpl='billets sélectionnés';
              if(qtAll==countcheck){codcheckEv='checked';};
            };
            $('.contLiTpl').append('<div id="'+x[i]._id+'" class="'+cliev+'" ><div class="hliEv"><div class="contcheckEv"><input type="checkbox" class="inCheckEv" id="inCheckEv'+x[i]._id+'" '+codcheckEv+'><label class="labCheckEv" for="inCheckEv'+x[i]._id+'"><i class="fas fa-check icCheckEv"></i></label></div><div class="nameEv">'+evname+'</div><div class="checkTplEv"><div class="bulcheckTplEv '+stybulcheckEv+'"><span class="qtcheckev">'+countcheck+'</span><span> / '+qtAll+'</span></div><div class="txtcheckTplEv">'+txtnbtpl+'</div></div><div class="contextandEv"><i class="far fa-chevron-down icextandEv"></i></div></div><div class="contblocSource"><div class="'+cbs[0]+'"><div class="hbs"><div class="contcheckSrc"><input type="checkbox" class="inCheckSrc" id="inCheckSrc'+n+'A'+x[i]._id+'" '+codcheckSrc[0]+'><label class="labCheckSrc" for="inCheckSrc'+n+'A'+x[i]._id+'"><i class="fas fa-check icCheckSrc"></i></label></div><div class="nameSrc"><i class="fas fa-ticket-alt" aria-hidden="true"></i> &nbsp; Billetterie en ligne</div><div class="checkTplSrc"><div class="bulcheckTplSrc '+stybulcheckSrc[0]+'"><span class="qtchecksrc">'+qtcheckOnline+'</span><span> / '+qtOnline+'</span></div></div>'+hins1+'</div><div class="bbs">'+csOnline+'</div></div><div class="'+cbs[1]+'"><div class="hbs"><div class="contcheckSrc"><input type="checkbox" class="inCheckSrc" id="inCheckSrc'+n+'B'+x[i]._id+'" '+codcheckSrc[1]+'><label class="labCheckSrc" for="inCheckSrc'+n+'B'+x[i]._id+'"><i class="fas fa-check icCheckSrc"></i></label></div><div class="nameSrc"><i class="fas fa-cash-register" aria-hidden="true"></i> &nbsp; Billetterie sur place</div><div class="checkTplSrc"><div class="bulcheckTplSrc '+stybulcheckSrc[1]+'"><span class="qtchecksrc">'+qtcheckOnsite+'</span><span> / '+qtOnsite+'</span></div></div>'+hins2+'</div><div class="bbs">'+csOnsite+'</div></div><div class="'+cbs[2]+'" style="margin-right:0%"><div class="hbs"><div class="contcheckSrc"><input type="checkbox" class="inCheckSrc" id="inCheckSrc'+n+'D'+x[i]._id+'" '+codcheckSrc[2]+'><label class="labCheckSrc" for="inCheckSrc'+n+'D'+x[i]._id+'"><i class="fas fa-check icCheckSrc"></i></label></div><div class="nameSrc"><i class="fas fa-file-import" style="transform:translateX(-2px)"></i> &nbsp; Importations</div><div class="checkTplSrc"><div class="bulcheckTplSrc '+stybulcheckSrc[2]+'"><span class="qtchecksrc">'+qtcheckImport+'</span><span> / '+qtImport+'</span></div></div>'+hins3+'</div><div class="bbs">'+csImport+'</div></div></div></div>');
          };
        }else{
          $('.txtnoev').fadeIn(0);
        };
      };
      //--------------------------------------------------------------------------
      //--- Fonctions / Actions  : -----------------------------------------------
      var cts=0;
      var s=0
      var v=0;
      var v1=0;
      var v2=0;
      var bb=0;
      var gg=0;
      var c=0;
      var hcs=0;
      var mis=0;
      var tis=0;
      var ois=0;
      var mcs=0;
      $('.contTpl').scroll(function(){
        cts=$(this).scrollTop();
        if(cts<0){
          cts=0;
        }else if(cts>maxScroll){
          cts=maxScroll;
        };
        if(s>270 || bb!=0){
          if(s>cts){
            if(bb==0 || bb==2){
              bb=1;
              v=cts;
              v1=gg;
            };
            s=cts;
            if(gg<=0){
              gg=0;
            }else{
              if(v1>270){
                gg=270-(v-cts);
              }else{
                gg=v1-(v-cts);
              };
            };
          }else{
            if(bb==1){
              bb=2;
              v=cts;
              v2=gg;
            };
            s=cts;
            gg=(cts-v)+v2;
          };
        }else{
          s=cts;
          gg=s;
        };
        c=gg*0.26;
        hcs=70-c;
        mis=16-(c*0.24);
        ois=1-(c*0.019);
        tis=1-(c*0.009);
        mcs=-40+(c*0.29);
        $('.contsearchResp').css({'height':hcs});
        $('.searchRespTpl').css({'margin-top':mis,'opacity':ois});
        $('.searchicResp').css({'margin-top':mcs,'transform':'scale('+tis+')','opacity':ois});
        $('.cleanSearchResp').css({'margin-top':mcs,'transform':'scale('+tis+')'});
        if(term){
          $('.cleanSearchResp').css({'opacity':ois});
        };
        if(gg>=270){
          $('.contsearchResp').css({'margin-top':'69px'});
        }else{
          $('.contsearchResp').css({'margin-top':'70px'});
        };
      });
      $('.contTpl').on('click','.nameEv, .checkTplEv, .contextandEv',function(){
        var tp=$(this).parent().parent();
        $('.blocSource').removeClass('bsOn');
        if(tp.attr('class')=='liEv'){
          $('.liEv').removeClass('liEvon');
          tp.addClass('liEvon');
        }else{
          $('.liEv').removeClass('liEvon');
        };
      });
      $('.contTpl').on('click','.hbs',function(){
        var tp=$(this).parent();
        if(tp.attr('class')=='blocSource'){
          $('.blocSource').removeClass('bsOn');
          tp.addClass('bsOn');
        }else{
          $('.blocSource').removeClass('bsOn');
        };
      });
      var term='';
      function searchTpl(){
        $('.liEv').attr('class','liEv')
        $('.blocSource').attr('class','blocSource').css({'display':'block'});
        $('.liTpl').css({'display':'block'});
        var termFound=0;
        if(term){
          $('.cleanSearch,.cleanSearchResp').css({'opacity':'1','pointer-events':'visible'});
          if(dataEvents.length>0){
            $('.blocSource').css({'display':'none'});
            $('.liTpl').css({'display':'none'});
            for(var i=0;i<dataEvents.length;i++){
              var termFoundinEv=0;
              dataEvents[i].tplOnline.filter(function(e){
                if((e.name.search(term)!=-1)
                  ||(e.name.search(term.toUpperCase())!=-1)
                  ||(e.name.search(term.substr(0,1)+term.substr(1).toLowerCase())!=-1)
                  ||(e.name.search(term.substr(0,1).toUpperCase()+term.substr(1))!=-1)
                  ||(e.name.search(term.toLowerCase())!=-1)){
                  var liname=highlight(e.name,term);
                  $('.liEv').eq(i).find('.blocSource:eq(0)').attr('class','blocSource bsOn').css({'display':'block'}).find('#'+e._id+'').css({'display':'block'}).find('.nameTpl').html(liname);
                  termFoundinEv=1;
                };
              });
              dataEvents[i].tplOnsite.filter(function(e){
                if((e.name.search(term)!=-1)
                  ||(e.name.search(term.toUpperCase())!=-1)
                  ||(e.name.search(term.substr(0,1)+term.substr(1).toLowerCase())!=-1)
                  ||(e.name.search(term.substr(0,1).toUpperCase()+term.substr(1))!=-1)
                  ||(e.name.search(term.toLowerCase())!=-1)){
                  var liname=highlight(e.name,term);
                  $('.liEv').eq(i).find('.blocSource:eq(1)').attr('class','blocSource bsOn').css({'display':'block'}).find('#'+e._id+'').css({'display':'block'}).find('.nameTpl').html(liname);
                  termFoundinEv=1;
                };
              });
              dataEvents[i].tplImport.filter(function(e){
                if((e.name.search(term)!=-1)
                  ||(e.name.search(term.toUpperCase())!=-1)
                  ||(e.name.search(term.substr(0,1)+term.substr(1).toLowerCase())!=-1)
                  ||(e.name.search(term.substr(0,1).toUpperCase()+term.substr(1))!=-1)
                  ||(e.name.search(term.toLowerCase())!=-1)){
                  var liname=highlight(e.name,term);
                  $('.liEv').eq(i).find('.blocSource:eq(2)').attr('class','blocSource bsOn').css({'display':'block'}).find('#'+e._id+'').css({'display':'block'}).find('.nameTpl').html(liname);
                  termFoundinEv=1;
                };
              });
              if(termFoundinEv==1){
                $('.liEv').eq(i).attr('class','liEv liEvon');
                termFound=1;
              }else{
                $('.liEv').eq(i).attr('class','liEv liEvoff');
              };
            }; 
            if(termFound==0){
              $('.txtnoterm').fadeIn(0);
            }else{
              $('.txtnoterm').fadeOut(0);
            };
          };
        }else{
          $('.cleanSearch,.cleanSearchResp').css({'opacity':'0','pointer-events':'none'});
          $('.txtnoterm').fadeOut(0);
          for(var i=0;i<dataEvents.length;i++){
            for(var u=0;u<dataEvents[i].tplOnline.length;u++){
              $('.liEv').eq(i).find('.blocSource:eq(0)').find('#'+dataEvents[i].tplOnline[u]._id+'').find('.nameTpl').html(dataEvents[i].tplOnline[u].name);
            };
            for(var u=0;u<dataEvents[i].tplOnsite.length;u++){
              $('.liEv').eq(i).find('.blocSource:eq(1)').find('#'+dataEvents[i].tplOnsite[u]._id+'').find('.nameTpl').html(dataEvents[i].tplOnsite[u].name);
            };
            for(var u=0;u<dataEvents[i].tplImport.length;u++){
              $('.liEv').eq(i).find('.blocSource:eq(2)').find('#'+dataEvents[i].tplImport[u]._id+'').find('.nameTpl').html(dataEvents[i].tplImport[u].name);
            };
          };
        };
      };
      function highlight(a,b){
        var splitMod=0;
        var termtxt='';
        var lis=a.split(b);
        if(lis.length==1){lis=a.split(b.toUpperCase());splitMod=1;};
        if(lis.length==1){lis=a.split(b.substr(0,1).toUpperCase()+b.substr(1));splitMod=2;};
        if(lis.length==1){lis=a.split(b.substr(0,1)+b.substr(1).toLowerCase());splitMod=3;};
        if(lis.length==1){lis=a.split(b.toLowerCase());splitMod=4;};
        if(lis.length>1){
          a='';
          for(var d=0;d<lis.length;d++){
            if(d!=(lis.length)-1){
              if(splitMod==1){termtxt=b.toUpperCase();
              }else if(splitMod==2){termtxt=b.substr(0,1).toUpperCase()+b.substr(1);
              }else if(splitMod==3){termtxt=b.substr(0,1)+b.substr(1).toLowerCase();
              }else if(splitMod==4){termtxt=b.toLowerCase();
              }else{termtxt=b;};
              a+=lis[d]+cus[0]+termtxt+cus[1];
            }else{
              a+=lis[d];
            };
          };
        };
        return a;
      };
      $('.searchTpl').keyup(function(){
        term=$(this).val().toString()||'';
        searchTpl();
      });
      $('.cleanSearch').click(function(){
        $('.searchTpl').val('');
        term='';
        $('.txtnoterm').fadeOut(0);
        searchTpl();
      });
      $('.searchRespTpl').focus(function(){
        if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
          $(window).scrollTop(1)
          setTimeout(function(){
            $(window).scrollTop(1)
          },1);
        };
      });
      $('.searchRespTpl').keyup(function(){
        term=$(this).val().toString()||'';
        searchTpl();
      });
      $('.cleanSearchResp').click(function(){
        $('.searchRespTpl').val('');
        term='';
        $('.txtnoterm').fadeOut(0);
        searchTpl();
      });
      $('.closeheadInfoL').click(function(){
        $('.headerInfoL').css({'opacity':'0.0','height':'0px'});
        $('.contTpl').css({'max-height':'100vh'});
      });
      $('.contTpl').on('change','.inCheckEv',function(){
        var ti=$(this).parent().parent().next();
        if($(this).is(':checked')){
          fnmod(ti,'checked');
        }else{
          fnmod(ti,'');
        };
      });
      $('.contTpl').on('change','.inCheckSrc',function (){
        var ti=$(this).parent().parent().next();
        if($(this).is(':checked')){
          fnmod(ti,'checked');
        }else{
          fnmod(ti,'');
        };
      });
      $('.contTpl').on('change','.inCheckTpl',function (){
        var ti=$(this).parent().parent();
        if($(this).is(':checked')){
          fnmod(ti,'checked');
        }else{
          fnmod(ti,'');
        };
      });
      $('.contTpl').on('click','.continfinit',function (){
        var ti=$(this);
        var tip=ti.parent().parent();
        if(tip.attr('inf1')=='false'){
          tip.attr('inf1','true');
          ti.addClass('continfinitOn');
          if(tip.attr('mod1')!="checked"){
            fnmod(tip,'checked');
          }else{
            tip.find('.inScanTpl').addClass('inScanTplOff');
            fncountmod();
          };
        }else{
          tip.attr('inf1','false');
          ti.removeClass('continfinitOn');
          tip.find('.inScanTpl').removeClass('inScanTplOff');
          fncountmod();
        };
      });
      $('.contTpl').on('change','.inScanTpl',function(){
        var v=parseFloat($(this).val());
        if(isNaN(v) || v<0){
          $(this).val(1);
          v=1;
        };
        var ti=$(this);
        var tip=ti.parent().parent();
        $(tip).attr('nbscan1',v);
        if($(tip).attr('inf1')=='true'){
          $(tip).attr('inf1','false').find('.continfinit').removeClass('continfinitOn');
        };
        if(v>0 && tip.attr('mod1')!="checked"){
          fnmod(tip,'checked');
        }else if(v<=0 && tip.attr('mod1')=="checked"){
          fnmod(tip,'');
        }else{
          $(ti).removeClass('inScanTplOff');
          fncountmod();
        };
      });
      function fnmod(d,c){
        // 1) d = liTpl
        // 2) d = bbs
        // 3) d = contblocSource
        var propo=true;
        if(c=='checked'){propo=true;}else{propo=false;};
        if($(d).attr('class')=='liTpl '|| $(d).attr('class')=='liTpl liTplG'){
          $(d).attr('mod1',c).find('.inCheckTpl').prop('checked',propo);
          if(propo==true){
            if($(d).attr('inf1')=='true'){
              $(d).find('.inScanTpl').addClass('inScanTplOff');
            }else{
              $(d).find('.inScanTpl').removeClass('inScanTplOff');
            };
            if(parseInt($(d).attr('nbscan1'))<1){
              $(d).attr('nbscan1','1').find('.inScanTpl').val(1);
            };
          }else if(propo==false){
            $(d).find('.continfinit').removeClass('continfinitOn'); 
            $(d).find('.inScanTpl').addClass('inScanTplOff');
            if($(d).attr('inf1')=='true'){
              $(d).attr('inf1','false');
            };
            if(parseInt($(d).attr('nbscan1'))>0){
              $(d).attr('nbscan1','0').find('.inScanTpl').val(0);
            };
          };
        }else if($(d).attr('class')=='bbs'){
          $(d).find('.liTpl').each(function(){
            $(this).attr('mod1',c).find('.inCheckTpl').prop('checked',propo);
            if(propo==true){
              if($(this).attr('inf1')=='true'){
                $(this).find('.inScanTpl').addClass('inScanTplOff');
              }else{
                $(this).find('.inScanTpl').removeClass('inScanTplOff');
              };
              if(parseInt($(this).attr('nbscan1'))<1){
                $(this).attr('nbscan1','1').find('.inScanTpl').val(1);
              };
            }else if(propo==false){
              $(this).find('.continfinit').removeClass('continfinitOn');
              $(this).find('.inScanTpl').addClass('inScanTplOff');
              if($(this).attr('inf1')=='true'){
                $(this).attr('inf1','false');
              };
              if(parseInt($(this).attr('nbscan1'))>0){
                $(this).attr('nbscan1','0').find('.inScanTpl').val(0);
              };
            };
          });  
        }else if($(d).attr('class')=='contblocSource'){
          $(d).find('.bbs').each(function(){
            $(this).find('.liTpl').each(function(){
              $(this).attr('mod1',c).find('.inCheckTpl').prop('checked',propo);
              if(propo==true){
                if($(this).attr('inf1')=='true'){
                  $(this).find('.inScanTpl').addClass('inScanTplOff');
                }else{
                  $(this).find('.inScanTpl').removeClass('inScanTplOff');
                };
                if(parseInt($(this).attr('nbscan1'))<1){
                  $(this).attr('nbscan1','1').find('.inScanTpl').val(1);
                };
              }else if(propo==false){
                $(this).find('.continfinit').removeClass('continfinitOn');
                $(this).find('.inScanTpl').addClass('inScanTplOff');
                if($(this).attr('inf1')=='true'){
                  $(this).attr('inf1','false');
                };
                if(parseInt($(this).attr('nbscan1'))>0){
                  $(this).attr('nbscan1','0').find('.inScanTpl').val(0);
                };
              };
            });
            $(this).prev().find('.inCheckSrc').prop('checked',propo);
          });
        }else{};
        fncountmod();
      };
      var countmod=0;
      var countTplSrc=0;
      var countTplEv=0;
      var countCheckTplSrc=0;
      var countCheckTplEv=0;
      var checkList={tpl:[]};
      function fncountmod(){
        countmod=0;
        checkList={tpl:[]};
        $('.liEv').each(function(){
          countTplEv=0;
          countCheckTplEv=0;
          $(this).find('.blocSource').each(function(){
            countTplSrc=0;
            countCheckTplSrc=0;
            $(this).find('.liTpl').each(function(){
              countTplSrc++;
              countTplEv++;
              if(($(this).attr('mod0')!=$(this).attr('mod1')) || ($(this).attr('nbscan0')!=$(this).attr('nbscan1')) || ($(this).attr('inf0')!=$(this).attr('inf1'))){
                countmod++;
              };
              if($(this).attr('mod1')=='checked'){
                countCheckTplSrc++;
                countCheckTplEv++;
                var idt=$(this).attr('id');
                var nbs=parseInt($(this).attr('nbscan1'));
                var inf=false;
                checkList.tpl.push({
                  "id": idt,
                  "scanNbr": nbs
                });
                // Avec Infinity : 
                /* if($(this).attr('inf1')=='true'){
                  inf=true;
                };
                checkList.tpl.push({
                  "id": idt,
                  "scanNbr": nbs,
                  "infinity": inf
                }); */
              };
            });
            $(this).find('.qtchecksrc').html(countCheckTplSrc);
            if(countCheckTplSrc==0){
              $(this).find('.inCheckSrc').prop('checked',false);
              $(this).find('.bulcheckTplSrc').attr('class','bulcheckTplSrc bulcs1');
            }else if(countCheckTplSrc==countTplSrc){
              $(this).find('.inCheckSrc').prop('checked',true);
              $(this).find('.bulcheckTplSrc').attr('class','bulcheckTplSrc bulcs2');
            }else{
              $(this).find('.inCheckSrc').prop('checked',false);
              $(this).find('.bulcheckTplSrc').attr('class','bulcheckTplSrc bulcs2');
            };
          });
          $(this).find('.qtcheckev').html(countCheckTplEv);
          if(countCheckTplEv==0){
            $(this).find('.inCheckEv').prop('checked',false);
            $(this).find('.bulcheckTplEv').attr('class','bulcheckTplEv bulce1');
          }else if(countCheckTplEv==countTplEv){
            $(this).find('.inCheckEv').prop('checked',true);
            $(this).find('.bulcheckTplEv').attr('class','bulcheckTplEv bulce2');
          }else{
            $(this).find('.inCheckEv').prop('checked',false);
            $(this).find('.bulcheckTplEv').attr('class','bulcheckTplEv bulce2');
          };
        });
        if(countmod==0){
          $('.blocmodifL').html('');
          $('.btnsaveL').addClass('btnsaveLoff');
        }else if(countmod==1){
          $('.blocmodifL').html(''+countmod+' modification non-sauvegardée <span class="annulmod"><i class="fa-solid fa-xmark" style="transform:translateX(8px)translateY(1.2px);"></i></span>');
          $('.btnsaveL').removeClass('btnsaveLoff');
        }else{
          $('.blocmodifL').html(''+countmod+' modifications non-sauvegardées <span class="annulmod"><i class="fa-solid fa-xmark" style="transform:translateX(8px)translateY(1.2px);"></i></span>');
          $('.btnsaveL').removeClass('btnsaveLoff');
        };
      };
      $('.blocmodifL').on('click','.annulmod',function(){
        checkList={tpl:[]};
        $('.blocmodifL').html('');
        $('.btnsaveL').addClass('btnsaveLoff').html('<i class="fas fa-save"></i>&nbsp; Sauvegarder ');;;
        $('.liEv').each(function(){
          countTplEv=0;
          countCheckTplEv=0;
          $(this).find('.blocSource').each(function(){
            countTplSrc=0;
            countCheckTplSrc=0;
            $(this).find('.liTpl').each(function(){
              countTplSrc++;
              countTplEv++;
              var m0=$(this).attr('mod0');
              var s0=$(this).attr('nbscan0');
              var i0=$(this).attr('inf0');
              $(this).attr('mod1',m0).attr('nbscan1',s0).attr('inf1',i0).find('.inScanTpl').val(s0);
              if(m0=='checked'){
                $(this).find('.inCheckTpl').prop('checked',true);
                if(i0=='false'){
                  $(this).find('.continfinit').removeClass('continfinitOn');
                  $(this).find('.inScanTpl').removeClass('inScanTplOff');
                }else{
                  $(this).find('.continfinit').addClass('continfinitOn');
                  $(this).find('.inScanTpl').addClass('inScanTplOff');
                };
              }else{
                $(this).find('.inCheckTpl').prop('checked',false);
                $(this).find('.continfinit').removeClass('continfinitOn');
                $(this).find('.inScanTpl').addClass('inScanTplOff');
              };
              if(m0=='checked'){
                countCheckTplSrc++;
                countCheckTplEv++;
              };
            });
            $(this).find('.qtchecksrc').html(countCheckTplSrc);
            if(countCheckTplSrc==0){
              $(this).find('.inCheckSrc').prop('checked',false);
              $(this).find('.bulcheckTplSrc').attr('class','bulcheckTplSrc bulcs1');
            }else if(countCheckTplSrc==countTplSrc){
              $(this).find('.inCheckSrc').prop('checked',true);
              $(this).find('.bulcheckTplSrc').attr('class','bulcheckTplSrc bulcs2');
            }else{
              $(this).find('.inCheckSrc').prop('checked',false);
              $(this).find('.bulcheckTplSrc').attr('class','bulcheckTplSrc bulcs2');
            };
          });
          $(this).find('.qtcheckev').html(countCheckTplEv);
          if(countCheckTplEv==0){
            $(this).find('.inCheckEv').prop('checked',false);
            $(this).find('.bulcheckTplEv').attr('class','bulcheckTplEv bulce1');
          }else if(countCheckTplEv==countTplEv){
            $(this).find('.inCheckEv').prop('checked',true);
            $(this).find('.bulcheckTplEv').attr('class','bulcheckTplEv bulce2');
          }else{
            $(this).find('.inCheckEv').prop('checked',false);
            $(this).find('.bulcheckTplEv').attr('class','bulcheckTplEv bulce2');
          };
        });        
      });
      var checlic=0;
      $('.btnsaveL').click(function(){
        if(checlic==0){
          checlic=1;
          $(this).html('Sauvegarde en cours...');
          t.boService.editTplList(checkList).then((data) => {
            $('.blocmodifL').html('');
            $('.btnsaveL').addClass('btnsaveLoff').html('<i class="fas fa-save"></i>&nbsp; Sauvegarder ');;
            $('.liTpl').each(function(){
              $(this).attr('mod0',$(this).attr('mod1'));
              $(this).attr('nbscan0',$(this).attr('nbscan1'));
              $(this).attr('inf0',$(this).attr('inf1'));
            });
            checlic=0;
          }).catch(error => {
            checlic=0;
          });
        };
      });
      //--------------------------------------------------------------------------
    });
  };
}